import N8nCallout from './Callout.vue';
export type { CalloutTheme } from '../../types';
export default N8nCallout;
